<template>
  <gj-input
      v-bind="$attrs"
      v-on="$listeners"
      :style="{width}"
      isEnter
      clearable>
    <template #suffix>
      <slot name="suffix">
<!--      <i class="el-input__icon el-icon-search"-->
<!--         @click="$emit('search')"-->
<!--      ></i>-->
      </slot>
    </template>
  </gj-input>
</template>

<script>
  import GjInput from "./gj-input";
  
  export default {
    name: "gj-search-input",
    components: {GjInput},
    props: {
      width: {
        type: String,
        default: '100px'
      }
    }
  }
</script>

<style scoped>
  .el-icon-search {
    cursor: pointer;
  }
</style>
